import { ReactElement, ReactNode } from 'react';
import Image from 'next/image';
import clsx from 'clsx';

import { Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';
import { PaymentType } from '@/interfaces';

interface Props {
	name: PaymentType;
	children: ReactNode;
	showModal: () => void;
	isAdded?: boolean;
}

export const PaymentCard: React.FC<Props> = ({
	name,
	children,
	isAdded,
	showModal,
}) => {
	const getInformation = (): { logo: ReactElement; label: string } => {
		let logo: ReactElement = <></>;
		let label = '';

		if (name === 'personal-account') {
			logo = <Icon src={Icons.emptyWallet} className="!w-5 !h-5" />;
			label = 'Add a Personal Checking Account';
		}

		if (name === 'paypal') {
			logo = (
				<Image
					src={'/img/dashboard/paypal.png'}
					alt=""
					width={18}
					height={18}
					quality={75}
				/>
			);
			label = 'Add a Paypal Account';
		}

		if (name === 'venmo') {
			logo = (
				<Image
					src={'/img/dashboard/venmo.png'}
					alt=""
					width={20}
					height={20}
					quality={75}
				/>
			);
			label = 'Add a Venmo Account';
		}
		return {
			logo,
			label,
		};
	};

	const { logo, label } = getInformation();

	return (
		<>
			<div
				className={clsx(
					'w-full py-6 px-8 bg-white rounded-3xl border border-green-secondary',
					'flex flex-col gap-6'
				)}
			>
				<div className="flex items-center justify-between">
					<div className="flex items-center gap-2">
						<div>{logo}</div>
						<Typography type="semibold-16" className="line-clamp-1">
							{label}
						</Typography>
					</div>
					{isAdded && (
						<button
							type="button"
							className="hover:opacity-60"
							onClick={showModal}
						>
							<Image
								alt="delete payment"
								src={Icons.trashPNG}
								width={16}
								height={16}
								className="text-primary"
								unoptimized
							/>
						</button>
					)}
				</div>
				<div className="space-y-4">{children}</div>
			</div>
		</>
	);
};
